import PropTypes from 'prop-types';
import React from 'react';
import { PageProvider, Page } from 'contexts/PageContext';
import CustomIntlProvider from 'components/CustomIntlProvider';
import * as styles from './styles/styles.module.scss';
import useWindowWidth from '../../hooks/useWindowWidth';
import SectionSwitch from '../../components/SectionSwitch';
import HomeHeader from '../../components/blocks/HomeHeader';
import SectionPropType from '../../proptypes/SectionPropType';
import LanguageRegionCodePropType from '../../proptypes/LanguageRegionCodePropType';
import SearchInsightsProvider from '../../components/SearchInsightsProvider';

const HomePage = ({ context, locationData, heroData, json, lists }) => {
  const windowWidth = useWindowWidth();

  return (
    <CustomIntlProvider>
      <PageProvider page={Page.Home}>
        <SearchInsightsProvider context={context} pageName={Page.Home}>
          <div id="modalPortal" />
          <main className={styles.container}>
            <HomeHeader windowWidth={windowWidth} latLng={locationData.latLng} context={context} greetings={json.greetings} heroData={heroData} />
            <SectionSwitch initialSections={json.sections} context={context} windowWidth={windowWidth} lists={lists} locationData={locationData} />
          </main>
        </SearchInsightsProvider>
      </PageProvider>
    </CustomIntlProvider>
  );
};

HomePage.propTypes = {
  context: PropTypes.shape({
    languageRegionCode: LanguageRegionCodePropType.isRequired
  }).isRequired,
  heroData: PropTypes.shape({
    greetingIndex: PropTypes.number.isRequired
  }).isRequired,
  json: PropTypes.shape({
    sections: PropTypes.arrayOf(SectionPropType).isRequired
  }).isRequired,
  lists: PropTypes.shape({
    listItems: PropTypes.array,
    lists: PropTypes.array
  }).isRequired,
  locationData: PropTypes.shape({
    country: PropTypes.string.isRequired,
    latLng: PropTypes.array.isRequired
  }).isRequired
};

export default HomePage;
